import React from 'react';

import { WrapperStyled } from './Wrapper.styled';

export const Wrapper = (props: React.PropsWithChildren) => {
  return <WrapperStyled>{props.children}</WrapperStyled>;
};
